import Image from "next/image";
import Link from "next/link";

import { blurDataURL } from "../../../utils/constants/images";
import { NEWS_LIST_URL } from "../../../utils/constants/websiteUrls";
import Badge from "../../common/Badge";
import RedDividerH from "../../common/RedDividerH";

const RecommendedNews = ({ recommendedNews }) => {
  return (
    <>
      <div className="max-w-prose mx-auto pt-4">
        <h2 className="font-extrabold text-lg text-center">Recommended</h2>
      </div>
      <div className="max-w-2xl mx-auto py-2 mb-10 px-6 md:max-w-3xl lg:max-w-5xl xl:max-w-5xl 2xl:max-w-7xl">
        <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 sm:grid-rows-2 sm:gap-x-6 lg:gap-8">
          {recommendedNews.map((article) => {
            return (
              <div
                key={article.id}
                className="group w-full h-80 aspect-w-2 aspect-h-1 rounded-md overflow-hidden transform transition duration-500 hover:scale-105"
              >
                <div className="object-center object-cover group-hover:opacity-75 sm:absolute sm:inset-0 sm:w-full sm:h-full">
                  <Image
                    src={article.thumbnail}
                    fill="true"
                    alt="Recommended News Thumbnail"
                    quality={100}
                    placeholder="blur"
                    blurDataURL={blurDataURL}
                    className="relative h-full w-full object-cover sm:object-fill md:object-cover lg:object-fill"
                  />
                </div>

                <div
                  aria-hidden="true"
                  className="w-full h-80 bg-gradient-to-b from-transparent to-black opacity-100 sm:absolute sm:inset-0"
                ></div>
                <div className="px-6 flex items-end sm:absolute sm:inset-0">
                  {article.category && (
                    <Badge categoryName={article.category.name} />
                  )}
                  <div>
                    <RedDividerH />

                    <h3 className="mt-2 mb-4 font-semibold text-white text-base lg:text-xl xl:text-xl 2xl:text-xl">
                      <Link href={`${NEWS_LIST_URL}/${article.slug}`}>
                        <span className="absolute inset-0"></span>
                        {article.title}
                      </Link>
                    </h3>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default RecommendedNews;
